function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
class FilterFecedForm extends HTMLElement {
  constructor() {
    super();

    this.backdropClose = this.querySelector('[data-backdrop-overlay]');
    this.filterbuttonMobileClose = this.querySelector('[data-drawer-close]');
    this.filterbuttonClose = this.querySelector('[data-button-filter-close]');
    if (this.filterClose) {
      this.filterClose.addEventListener('click', this.closeOverlay.bind(this));
    }

    if (this.backdropClose) {
      this.backdropClose.addEventListener('click', this.closeOverlay.bind(this));
    }

    if (this.filterbuttonClose) {
      this.filterbuttonClose.addEventListener('click', this.closeOverlay.bind(this));
    }
    this.filterbuttonMobileClose.addEventListener('click', this.closeOverlay.bind(this));


    document.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') {
        this.closeOverlay(event);
      }
    });
  
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    document.addEventListener('keydown', (event) => { 
      if (event.key === 'Enter') {
        const activeEl = document.activeElement;
        const facetForm = this.querySelector('form');
        if (facetForm && facetForm.contains(activeEl)) {
          if(activeEl.closest('div').querySelector('input')){
           activeEl.closest('div').querySelector('input').click();  
          }
        }
      }
    });
    this.handleCursorMove();
  }

  handleCursorMove() {
    const cursorWrapper = this.querySelector('[data-cursor-hover]');

    gsap.set(cursorWrapper, { xPercent: 0, yPercent: 0 });

    const xTo = gsap.quickTo(cursorWrapper, 'x', { duration: 0.2, ease: 'power3' });
    const yTo = gsap.quickTo(cursorWrapper, 'y', { duration: 0.2, ease: 'power3' });

    this.backdropClose.addEventListener('mousemove', (e) => {
      gsap.to(cursorWrapper, { opacity: 1, scale: 1, duration: 0.1 });
      xTo(e.clientX);
      yTo(e.clientY);
    });
    this.backdropClose.addEventListener('mouseleave', (e) => {
      gsap.to(cursorWrapper, { scale: 0, duration: 0.2 });
    });
    this.backdropClose.addEventListener('mouseenter', (e) => {
      gsap.to(cursorWrapper, { scale: 1, duration: 0.2 });
    });
  }

  addEventListeners() {
    this.addEventListener('mouseenter', (e) => this.handleMouseEnter(e));
    this.addEventListener('mouseleave', (e) => this.handleMouseLeave(e));
  }
  closeOverlay(event) {
    event.preventDefault();
    const sectionMain = this.closest('.shopify-section');
    const filterNav = sectionMain.querySelector('[data-filters-nav]');
    const dataType = sectionMain.querySelector('filter-toggler').getAttribute('data-filter-type');
    const filtersSidebar = sectionMain.querySelector('[data-collection-filters-wrapper]');
    filtersSidebar.querySelector('[data-filters-sidebar]').setAttribute('inert', 'true');
    const isOpened = filterNav.classList.toggle('filters-opened');
    if (dataType === 'drawer') {
      filtersSidebar.classList.remove('filters-overlay-drawer-open');
      unlockBodyScroll();
    } else {
      filtersSidebar.classList.toggle('show', isOpened);
      filterNav.innerText = isOpened ? hideFilters : showFilters;
    }
  }
  onActiveFilterClick(event) {
    event.preventDefault();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FilterFecedForm.renderPage(url);
  }
  createSearchParams(form) {
    return new URLSearchParams(new FormData(form)).toString();
  }
  onSubmitHandler(event) {
    event.preventDefault();
    const sortingFilterForms = this.closest('filter-faced-form').querySelectorAll('form');
    let forms = [];
    sortingFilterForms.forEach((sortingFilterForm) => {
      forms.push(this.createSearchParams(sortingFilterForm));
    });
    forms = forms.filter(function (el) {
      return el;
    });

    this.onSubmitForm(forms.join('&'), event);
  }
  onSubmitForm(searchParams, event) {
    const query = document.querySelector('[search-page-input]');
    if (query) {
      const queryValue = query.value;
      searchParams = `${searchParams}&type=product&q=${queryValue}`;
    }

    FilterFecedForm.renderPage(searchParams, event);
  }

  static updateURLHash(searchParams) {
    history.pushState(
      {
        searchParams,
      },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
    );
  }

  static getSections() {
    const collectioSection = document.getElementById('collection-list-grid');
    const searchSection = document.getElementById('search-list-grid');
    if (collectioSection) {
      return [
        {
          section: document.getElementById('collection-list-grid').dataset.id,
        },
      ];
    }
    if (searchSection) {
      return [
        {
          section: document.getElementById('search-list-grid').dataset.id,
        },
      ];
    }
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    let currentId = '';
    if(typeof event !== 'undefined'){
      currentId = event.target.id;
    }
    FilterFecedForm.searchParamsPrev = searchParams;
    const sections = FilterFecedForm.getSections();
    sections.forEach((section) => {
      const query = document.querySelector('[search-page-input]');
      if (query) {
        const queryValue = query.value;
        const url = `${window.location.pathname}?section_id=${section.section}&q=${queryValue}&${searchParams}`;
        FilterFecedForm.renderSectionFromFetch(url, event, currentId);
      } else {
        const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
        FilterFecedForm.renderSectionFromFetch(url, event, currentId);
      }
    
    });

    if (updateURLHash) {
      FilterFecedForm.updateURLHash(searchParams);
    }    

  }

  static renderSectionFromFetch(url, event , currentId) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FilterFecedForm.renderFiltersBar(html, event);
        FilterFecedForm.renderProductGrid(html);
         if(currentId != ''){
          document.getElementById(currentId).focus();
         }
      });
  }

  static renderProductGrid(html) {
;
    const resultData = new DOMParser().parseFromString(html, 'text/html');
    if (document.querySelector('[data-collections-grid]') && resultData.querySelector('[data-collections-grid]')) {
      document.querySelector('[data-collections-grid]').innerHTML =
        resultData.querySelector('[data-collections-grid]').innerHTML;
    }

  }
  static renderFiltersBar(html, event) {
    const resultData = new DOMParser().parseFromString(html, 'text/html');
    if (document.querySelector('[data-filters-sidebar]') && resultData.querySelector('[data-filters-sidebar]')) {
      document.querySelector('[data-filters-sidebar]').innerHTML =
        resultData.querySelector('[data-filters-sidebar]').innerHTML;
    }
  }
}
customElements.define('filter-faced-form', FilterFecedForm);

class PriceRangeFilters extends HTMLElement {
  constructor() {
    super();

    if (!this.querySelector('[data-range-bars]')) return;
    this.rangeBars = this.querySelectorAll('input[type=range]');
    this.numberFields = this.querySelectorAll('input[type=number]');
    this.progress = this.querySelector('[data-filter-progress]');

    this.thumbsGap = 1;

    this.rangeBars.forEach((rangeBar) => {
      rangeBar.addEventListener('input', this.rangeBarHandle.bind(this));
    });

    this.numberFields.forEach((numberField) => {
      numberField.addEventListener('input', this.numberFieldHandle.bind(this));
    });
  }

  rangeBarHandle(event) {
    this.rangeBars.forEach((el) => {
      let minVal = parseInt(this.rangeBars[0].value),
        maxVal = parseInt(this.rangeBars[1].value);

      if (maxVal - minVal < this.thumbsGap) {
        if (el.target.className === 'input-min') {
          this.rangeBars[0].value = maxVal - this.thumbsGap;
        } else {
          this.rangeBars[1].value = minVal + this.thumbsGap;
        }
      } else {
        this.numberFields[0].value = minVal;
        this.numberFields[1].value = maxVal;
        this.progress.style.left = (minVal / this.rangeBars[0].max) * 100 + '%';
        this.progress.style.right = 100 - (maxVal / this.rangeBars[1].max) * 100 + '%';
      }
    });
  }

  numberFieldHandle(event) {
    this.numberFields.forEach((el) => {
      let minPrice = parseFloat(this.numberFields[0].value),
        maxPrice = parseFloat(this.numberFields[1].value);

      if (maxPrice - minPrice >= this.thumbsGap && maxPrice <= this.rangeBars[1].max) {
        if (e.target.className === 'input-min') {
          this.rangeBars[0].value = minPrice;
          this.progress.style.left = (minPrice / this.rangeBars[0].max) * 100 + '%';
        } else {
          this.rangeBars[1].value = maxPrice;
          this.progress.style.right = 100 - (maxPrice / this.rangeBars[1].max) * 100 + '%';
        }
      }
    });
  }
}
customElements.define('price-range-bar', PriceRangeFilters);

class ClearAllFilters extends HTMLElement {
  constructor() {
    super();
    const removeLink = this.querySelector('a');
    removeLink.setAttribute('role', 'button');
    removeLink.addEventListener('click', this.clearFilter.bind(this));
    removeLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.clearFilter(event);
    });
  }

  clearFilter(event) {
    event.preventDefault();
    const form =
      this.closest('filter-faced-form') ||
      document.querySelector('filter-faced-form') ||
      document.querySelector('[data-filter-faced-form]');
    const forms = document.querySelector('[data-filter-faced-form]');

    if (forms) {
      forms.onActiveFilterClick(event);
    }
    form.onActiveFilterClick(event);
  }
}
customElements.define('filter-remove', ClearAllFilters);

class FilterToggler extends HTMLElement {
  constructor() {
    super();
    this.section = this.closest('section');
    this.filterNav = this.querySelector('[data-filters-nav]');
    this.filteroverlayNav = this.querySelector('[data-filter-overlay]');
    this.filtersSidebar = this.section.querySelector('[data-collection-filters-wrapper]');
    this.filterNav?.addEventListener('click', this.toggleFilterSidebar.bind(this));
    this.filterNav?.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.toggleFilterSidebar(event);
      }
    });
    this.handleScroll = this.handleScroll.bind(this);
  }

  connectedCallback() {
    // Now that the element is connected to the DOM, access the data attribute
    this.dataType = this.dataset.filterType;
    this.filterPagination = this.section.querySelector('[data-pagination-wrapper]');
    this.filterProducts = this.section.querySelector('[main-collection-products]');
    this.filterSticky = this.section.querySelector('[data-sticky-filter]').getAttribute('data-sticky-filter');
    this.filterEnableSticky = this.section
      .querySelector('[data-show-sticky-filter]')
      .getAttribute('data-show-sticky-filter');
    if (this.filterEnableSticky == 'true') {
      window.addEventListener('scroll', this.handleScroll);
    }
  }

  disconnectedCallback() {
    // Cleanup event listener when element is removed
    window.removeEventListener('scroll', this.handleScroll);
  }

  toggleFilterSidebar(event) {
    setTimeout(() => {
      this.section.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }, 500);
    event.preventDefault();
    document.querySelector('[data-filters-sidebar]').removeAttribute('inert');

    const isOpened = this.filterNav.classList.toggle('filters-opened');
    if (this.dataType == 'drawer') {
      this.filtersSidebar.classList.add('filters-overlay-drawer-open');
      lockBodyScroll();
    } else {
      this.filtersSidebar.classList.toggle('show', isOpened);
      this.filterNav.innerText = isOpened ? hideFilters : showFilters;
    }

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.filtersSidebar.querySelector('.main-collection-filter-wrapper');
        const focusElement = containerToTrapFocusOn.querySelector('input');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
 
  }

  handleScroll() {
    this.filterNavTop = this.filterNav.getBoundingClientRect().top;
    this.filterNavBottom = this.filterNav.getBoundingClientRect().bottom;
    if (this.filterPagination) {
      this.filterSectionTop = this.filterPagination.getBoundingClientRect().top;
    }
    this.filterProductTop = this.filterProducts.getBoundingClientRect().top;

    this.filterProductBottom = this.filterProducts.getBoundingClientRect().bottom;

    if (this.filterNavTop <= 0 && !this.filterNav.classList.contains('filters-overlay-visible')) {
      this.filterNav.classList.add('filters-overlay-visible');
    }

    if (this.filterProductBottom < window.innerHeight) {
      if (this.filterSticky == 'true') {
        this.filterNav.classList.remove('filters-overlay-visible');
      }
    } else {
      this.filterNav.classList.add('filters-overlay-visible');
    }

    // Remove class if filterProductTop is already off-screen at the top
    if (this.filterProductTop >= 0) {
      this.filterNav.classList.remove('filters-overlay-visible');
    }
  }
}

customElements.define('filter-toggler', FilterToggler);

class LoadMore extends HTMLElement {
  constructor() {
    super();
    this.onClickHandler = this.onClick.bind(this);
  }

  connectedCallback() {
    const button = this.querySelector('a');
    if (button) {
      button.addEventListener('click', this.onClickHandler);
    }

    if (this.getAttribute('data-mode') === 'infinite') {
      // 1. Assign observer to a class property so we can disconnect it later
      this.observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          this.fetchData();
        }
      });
      this.observer.observe(this);
    }
  }

  disconnectedCallback() {
    const button = this.querySelector('a');
    if (button) {
      button.removeEventListener('click', this.onClickHandler);
    }
    // 2. Disconnect observer when element is removed to prevent memory leaks
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  onClick(event) {
    event.preventDefault();
    this.fetchData();
  }

  fetchData() {
    // 3. MOVED GUARD HERE: Prevents multiple fetches from both Clicks AND Infinite Scroll
    if (this.hasAttribute('aria-busy')) return;

    this.enableLoading();

    const button = this.querySelector('a');
    if (!button) return;
    const url = button.getAttribute('href');

    if (!url) {
      console.warn('No URL found for load more button');
      this.disableLoading();
      return;
    }

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const parser = new DOMParser();
        const responseDoc = parser.parseFromString(responseText, 'text/html');

        const newProducts = responseDoc.querySelector('[main-collection-products]');
        const currentProducts = document.querySelector('[main-collection-products]');

        if (newProducts && currentProducts) {
          // 4. PERFORMANCE FIX: Use insertAdjacentHTML instead of innerHTML +=
          // This appends the new nodes without destroying/re-rendering the existing ones
          currentProducts.insertAdjacentHTML('beforeend', newProducts.innerHTML);

          const newButton = responseDoc.querySelector('load-more a');
          if (newButton) {
            button.setAttribute('href', newButton.getAttribute('href'));
          } else {
            // Disconnect observer before removing the element
            if (this.observer) this.observer.disconnect();
            this.remove();
          }
        }

        this.disableLoading();
        if (typeof ScrollTrigger !== 'undefined' && window.innerWidth >= 768) {
          ScrollTrigger.refresh();
        }
      })
      .catch((error) => {
        console.error('Error fetching load more content:', error);
        this.disableLoading();
      });
  }

  enableLoading() {
    this.querySelector('a').classList.add('hidden');
    
    const infiniteLoader = this.querySelector('[data-infinite-scroll]');
    if (infiniteLoader) infiniteLoader.classList.remove('hidden');
    
    this.setAttribute('aria-busy', 'true');
    this.classList.add('pointer-events-none');
  }

  disableLoading() {
    this.querySelector('a').classList.remove('hidden');
    
    const infiniteLoader = this.querySelector('[data-infinite-scroll]');
    if (infiniteLoader) infiniteLoader.classList.add('hidden');
    
    this.removeAttribute('aria-busy');
    this.classList.remove('pointer-events-none');
  }
}

customElements.define('load-more', LoadMore);
